import { useState } from 'react';

export default function useTouchDevice() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isTouchDevice, setIsTouchDevice] = useState(navigator.maxTouchPoints > 0);

  return isTouchDevice;
}
